import React, { PureComponent } from "react";
import PropTypes from "prop-types";
// Material imports
import withStyles from "@mui/styles/withStyles";
// Limitless improts
import { withi18n } from "../hocs/i18n";
class ToolTip extends PureComponent {
  render() {
    const {
      title,
      children,
      t,
      classes,
      customClass
    } = this.props;
    return /*#__PURE__*/React.createElement("div", {
      "data-title": t(title),
      className: `${classes.tooltip} ${classes.expand} ${customClass}`
    }, children);
  }
}
const styles = theme => {
  var _theme$palette$grey$, _theme$palette, _theme$palette$contra, _theme$palette$contra2, _theme$palette$contra3, _theme$palette2;
  return {
    icon: {
      width: "0.9em"
    },
    tooltip: {
      "&:before, &:after": {
        display: "block",
        opacity: "0",
        pointerEvents: "none",
        position: "absolute"
      },
      "&:before": {
        backgroundColor: theme.palette.tooltip ? theme.palette.tooltip.backgroundColor : (_theme$palette$grey$ = theme.palette.grey[4]) !== null && _theme$palette$grey$ !== void 0 ? _theme$palette$grey$ : (_theme$palette = theme.palette) === null || _theme$palette === void 0 ? void 0 : (_theme$palette$contra = _theme$palette.contrast) === null || _theme$palette$contra === void 0 ? void 0 : _theme$palette$contra.light,
        borderRadius: 4,
        color: theme.palette.tooltip ? theme.palette.tooltip.textColor : (_theme$palette$contra2 = (_theme$palette$contra3 = theme.palette.contrast) === null || _theme$palette$contra3 === void 0 ? void 0 : _theme$palette$contra3.main) !== null && _theme$palette$contra2 !== void 0 ? _theme$palette$contra2 : (_theme$palette2 = theme.palette) === null || _theme$palette2 === void 0 ? void 0 : _theme$palette2.primary.contrastText,
        content: "attr(data-title)",
        fontSize: 13,
        fontFamily: theme.typography.fontFamily,
        padding: "8px 10px 8px 10px",
        right: 30,
        bottom: -7,
        width: "fit-content",
        lineHeight: "1.1rem",
        display: "flex",
        flex: 1,
        alignItems: "center"
      }
    },
    expand: {
      "&:before": {
        transform: "scale3d(.2,.2,1)",
        transition: "all .2s ease-in-out"
      },
      "&:after": {
        transform: "translate3d(0,6px,0)",
        transition: "all .1s ease-in-out"
      },
      "&:hover:before, &:hover:after": {
        opacity: "1",
        transform: "scale3d(1,1,1)",
        zIndex: 1
      },
      "&:hover:after": {
        transition: "all .2s .1s ease-in-out"
      }
    }
  };
};
export default withStyles(styles)(withi18n(ToolTip));
ToolTip.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.node]),
  classes: PropTypes.object.isRequired,
  position: PropTypes.string,
  t: PropTypes.func.isRequired,
  customClass: PropTypes.string
};